import { DIM_COLOR } from "@/components/DimensionBar";

const NAMES = {
  self_relationship: "Relationship with Self", external_validation: "Use of External Validation",
  fear_uncertainty: "Fear & Uncertainty", scaffolding: "Scaffolding", intentional_practice: "Intentional Practice",
  future_orientation: "Future Orientation", joy_freedom_play: "Joy, Freedom & Play",
};
const PATTERNS = {
  self_relationship: /relationship with (the )?self/i, external_validation: /external validation/i,
  fear_uncertainty: /fear (&|and) uncertainty/i, scaffolding: /scaffolding/i, intentional_practice: /intentional practice/i,
  future_orientation: /future orientation/i, joy_freedom_play: /joy,? freedom (&|and) play|freedom (&|and) play/i,
};

// Dimensions a piece of Portrait text actually names, in canonical order (same rule as the PDF).
export const dimsInText = (...texts) => {
  const t = texts.flat().filter(Boolean).join(" ");
  return Object.keys(PATTERNS).filter((k) => PATTERNS[k].test(t) || t.includes(k));
};

// On the dark Portrait page the two greens read alike; lift Intentional Practice and ring every dot.
const ON_DARK = { intentional_practice: "#A8CBB0" };

const SHORT = { self_relationship: "Self", external_validation: "External Validation", fear_uncertainty: "Fear & Uncertainty", scaffolding: "Scaffolding", intentional_practice: "Intentional Practice", future_orientation: "Future Orientation", joy_freedom_play: "Joy, Freedom & Play" };

// Seven dimension dots joined by a line, as on the report covers.
export const SevenDotsLine = ({ testId = "seven-dots" }) => (
  <div className="relative grid grid-cols-7 max-w-2xl my-6 gap-1" data-testid={testId}>
    <div className="absolute left-[7%] right-[7%] top-3.5 border-t border-dashed border-[rgba(255,255,255,0.18)]" />
    {Object.keys(NAMES).map((k) => (
      <div key={k} className="relative flex flex-col items-center text-center">
        <span title={NAMES[k]} className="w-7 h-7 rounded-full flex items-center justify-center" style={{ backgroundColor: `${ON_DARK[k] || DIM_COLOR[k]}33` }}>
          <span className="w-3.5 h-3.5 rounded-full" style={{ backgroundColor: ON_DARK[k] || DIM_COLOR[k] }} />
        </span>
        <span className="mt-1.5 text-[10px] sm:text-[11px] leading-tight text-[#9CA3AF]">{SHORT[k]}</span>
      </div>
    ))}
  </div>
);

export const ConnectsRow = ({ steps, title = "How your Portrait connects", testId = "connects-row" }) => (
  <div className="mt-6" data-testid={testId}>
    <p className="cg-eyebrow mb-3">{title}</p>
    <div className="flex flex-col sm:flex-row items-stretch gap-2">
      {steps.map((st, i) => (
        <div key={st} className="flex flex-col sm:flex-row items-center sm:items-stretch gap-2 flex-1">
          <div className="flex-1 w-full flex items-center justify-center text-center text-sm text-[#E8EAEE] bg-[#0D0E12] border border-[var(--cg-border)] rounded-xl px-3 py-3">{st}</div>
          {i < steps.length - 1 && <span className="text-brass self-center">{"\u2192"}</span>}
        </div>
      ))}
    </div>
  </div>
);

export const PracticeCards = ({ items, label, testId, accent = "#D9A25F" }) => (
  <div className="grid md:grid-cols-2 gap-4" data-testid={testId}>
    {items.map((t, i) => (
      <div key={i} className="bg-[#0D0E12] border border-[var(--cg-border)] rounded-xl p-5" style={{ borderTop: `2px solid ${accent}` }}>
        <p className="font-mono text-xs mb-2" style={{ color: accent }}>{label} {String(i + 1).padStart(2, "0")}</p>
        <div className="mb-2"><DimDots keys={dimsInText(t)} /></div>
        <p className="text-sm text-[#B9BDC7] leading-relaxed">{t}</p>
      </div>
    ))}
  </div>
);

export const DimDots = ({ keys, testId, names = true }) => (
  keys.length ? (
    <div className="flex flex-wrap gap-x-4 gap-y-1.5" data-testid={testId}>
      {keys.map((k) => (
        <span key={k} className="inline-flex items-center gap-1.5 text-xs text-[#9CA3AF]" title={NAMES[k]}>
          <span className="w-2.5 h-2.5 rounded-full shrink-0" data-testid={`dot-${k}`}
            style={{ backgroundColor: ON_DARK[k] || DIM_COLOR[k], boxShadow: "0 0 0 1.5px rgba(255,255,255,0.22)" }} />{names && NAMES[k]}
        </span>
      ))}
    </div>
  ) : null
);
